import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';
import ContactWidgets from './components/ContactWidgets';
import Home from './pages/Home';
import Collection from './pages/Collection';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import CustomerLogin from './pages/CustomerLogin';
import Account from './pages/Account';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import DashboardHome from './admin/pages/DashboardHome';
import AdminProducts from './admin/pages/AdminProducts';
import AdminCategories from './admin/pages/AdminCategories';
import AdminCustomers from './admin/pages/AdminCustomers';
import AdminSales from './admin/pages/AdminSales';
import AdminInventory from './admin/pages/AdminInventory';
import AdminReports from './admin/pages/AdminReports';

function StorefrontLayout({ children, cartCount, customer, setCustomer }) {
  return (
    <>
      <Navbar cartCount={cartCount} customer={customer} />
      <main className="main-content">{children}</main>
      <Footer />
      <BottomNav cartCount={cartCount} customer={customer} />
      <ContactWidgets />
    </>
  );
}

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [customer, setCustomer] = useState(null);

  const addToCart = (product) => {
    const existingItem = cartItems.find(item => item.id === product.id);
    if (existingItem) {
      setCartItems(cartItems.map(item =>
        item.id === product.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCartItems([...cartItems, { ...product, quantity: 1 }]);
    }
  };

  const removeFromCart = (productId) => {
    setCartItems(cartItems.filter(item => item.id !== productId));
  };

  const updateCartQuantity = (productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
    } else {
      setCartItems(cartItems.map(item =>
        item.id === productId ? { ...item, quantity } : item
      ));
    }
  };

  const clearCart = () => setCartItems([]);

  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Storefront Routes */}
          <Route path="/" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <Home addToCart={addToCart} />
            </StorefrontLayout>
          } />
          <Route path="/collection" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <Collection addToCart={addToCart} />
            </StorefrontLayout>
          } />
          <Route path="/about" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <About />
            </StorefrontLayout>
          } />
          <Route path="/contact" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <Contact />
            </StorefrontLayout>
          } />
          <Route path="/cart" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <Cart
                cartItems={cartItems}
                removeFromCart={removeFromCart}
                updateCartQuantity={updateCartQuantity}
              />
            </StorefrontLayout>
          } />
          <Route path="/checkout" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <Checkout cartItems={cartItems} clearCart={clearCart} customer={customer} />
            </StorefrontLayout>
          } />
          <Route path="/order-success" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <OrderSuccess />
            </StorefrontLayout>
          } />
          <Route path="/login" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <CustomerLogin setCustomer={setCustomer} />
            </StorefrontLayout>
          } />
          <Route path="/account" element={
            <StorefrontLayout cartCount={cartCount} customer={customer} setCustomer={setCustomer}>
              <Account customer={customer} setCustomer={setCustomer} />
            </StorefrontLayout>
          } />

          {/* Admin Routes */}
          <Route path="/admin" element={
            isAdmin ? <Navigate to="/admin/dashboard" replace /> : <AdminLogin setIsAdmin={setIsAdmin} />
          } />
          <Route path="/admin/*" element={
            isAdmin ? (
              <AdminLayout setIsAdmin={setIsAdmin}>
                <Routes>
                  <Route path="dashboard" element={<DashboardHome />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="categories" element={<AdminCategories />} />
                  <Route path="customers" element={<AdminCustomers />} />
                  <Route path="sales" element={<AdminSales />} />
                  <Route path="inventory" element={<AdminInventory />} />
                  <Route path="reports" element={<AdminReports />} />
                  <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                </Routes>
              </AdminLayout>
            ) : (
              <Navigate to="/admin" replace />
            )
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
